export default __webpack_public_path__ + "static/media/avatar_bg_jiraiya.57a91dd3.png";